import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Leaderboard Settings</h4>
    </div>
  );
};
